module.exports = __webpack_public_path__ + "static/media/bannerIDE.0b5121a6.jpg";